<template>
  <div
    class="modal has-overflow"
    :class="{ 'is-active': value }">
    <div class="modal-background"
      @click="cancel()">
    </div>
    <div class="modal-content">
      <article class="message" :class="messageClass">
        <div class="message-header">
          <p>{{ title }}</p>
          <button
            class="delete"
            aria-label="delete"
            @click="cancel()">
          </button>
        </div>
        <div class="message-body has-text-centered">
          <p v-if="message" v-html="message">
          </p>
          <slot></slot>
          <p class="help">
            {{ note }}
          </p>
          <div class="buttons is-hcentered mt-3">
            <button
              class="button"
              :class="messageClass"
              :disabled="pending"
              @click="confirm()">
              {{ confirmText }}
            </button>
            <button 
              v-if="showCancel" 
              class="button" 
              :class="{ 'is-loading': pending }"
              :disabled="pending"
              @click="cancel()">
              {{ cancelText }}
            </button>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean
    },
    message : {
      type: [String, Number]
    },
    note: {
      type: [String, Number]
    },
    title: {
      type: [String, Number]
    },
    type: {
      type: String,
      default: null
    },
    confirmText: {
      type: String,
      default: 'Yes'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    pending: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    messageClass() {
      return [
        this.type ? `is-${this.type}` : null,
        this.pending ? 'is-loading' : null
      ]
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm');
    },
    cancel() {
      this.$emit('input', false);
      this.$emit('cancel', false);
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/modal.scss';

$desktop: 1024px;

.buttons.is-hcentered {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
}

.modal-content {
  width: 500px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  @media (max-width: $desktop) {
    max-width: 100vw;
    width: 100%;
    height: 100vh;
    max-height: 100vh !important;
  }
}
</style>